// Example service: filepath: /home/boss/workspace/pwa/zgrana/src/app/services/example.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Partner } from '../interfaces/partners.interface';
import { File as AppFile } from '../interfaces/files.interface';
import { DataProcessingService } from './data-prcessing.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EditOffer, Offer } from '../interfaces/offers.interface';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class OffersService { 

  public searchTitle: string = ''
  
  
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('offer');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) {}



   updateOffer(id: number, data: EditOffer): Observable<Offer> {
    return this.http.put<Offer>(`${this.apiUrl}/${id}`, data);
  }

  getData(id: number): Observable<Offer> {
    return this.http.get<Offer>(this.apiUrl + '/' + id);
  }

  createOffer(data: Partial<EditOffer>): Observable<Offer> {
    return this.http.post<Offer>(this.apiUrl, data);
  }

  deleteOffer(OfferId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${OfferId}`);
  }

  setActive(offer_id: number, active_value: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/set_active/${offer_id}/${active_value}`);
  }

  deleteFile(uuid: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/delete-image/${uuid}`);
  }
  
  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/upload-image`, formData);
  }


  getOffers(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<GenericResponseWithTotal<Offer>> {
    return this.http.get<GenericResponseWithTotal<Offer>>(this.apiUrl, { params: this.dataProcess.fitlerParams(params) });
  }

}